import React from "react";
import LoginForm from "src/components/forms/login/LoginForm";
import SocialLogin from "src/components/social-login";
import { useTranslation } from "react-i18next";
import { useBreakpointIsLowerOrEqual } from "src/hooks/responsive";
import { DialogContent, DialogTitle, DialogDescription } from "src/components/ui/dialog";
import { Button } from "src/components/ui/button";
import Divider from "src/components/ui/divider";

interface LoginPopupProps {
  setIsLogin: (value: boolean) => void;
  title?: string;
  description?: string;
}

const LoginPopup: React.FC<LoginPopupProps> = ({ title, description, setIsLogin }) => {
  const { t } = useTranslation();
  const isMobile = useBreakpointIsLowerOrEqual("sm");

  return (
    <DialogContent className="z-[1024]" overlayClassName="z-[1023]" hideClose={!isMobile}>
      <DialogTitle className="!text-xl !p-3 text-center">{title || t("Sign In")}</DialogTitle>
      {description && <DialogDescription className="!text-sm px-3 py-1.5 text-center mb-0">{description}</DialogDescription>}
      <div className="flex items-center justify-center gap-2">
        <span className="text-muted-foreground text-sm">{t("Don't have an account?")}</span>
        <Button variant="link" className="p-0 h-fit" onClick={() => setIsLogin(false)}>
          {t("Sign up here")}
        </Button>
      </div>
      <div className="flex-1 overflow-y-auto customScrollbar2 p-3 h-fit">
        <SocialLogin />
        <Divider className="my-2" text={t("common.or", "or") as string} />
        <LoginForm />
      </div>
    </DialogContent>
  );
};

export default LoginPopup;
